var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import "../shell/pas-banner";
import "../shell/chart-navigator";
import "../components/chart-viewer";
let PasPatientView = class PasPatientView extends LitElement {
    constructor() {
        super(...arguments);
        this.patientId = "";
        this.patient = null;
        this.focusedDoc = null;
    }
    static { this.styles = css `
    :host, *, *::before, *::after { box-sizing: border-box; }
    :host { display: grid; grid-template-rows: auto 1fr; height: 100vh;
            container-type: inline-size; container-name: ehr;
            border-radius: 10px; overflow: hidden; }
    .body { display: grid; grid-template-columns: 184px 1fr; gap: 12px; overflow: auto;
            padding: 12px; min-height: 0; }
    .body > * { min-width: 0; }
    @container ehr (max-width: 759px) { .body { grid-template-columns: 1fr; } }
  `; }
    onFocus(e) {
        const id = e.detail.docId;
        this.focusedDoc = this.patient.documents.find((d) => d.id === id) ?? null;
    }
    render() {
        if (!this.patient)
            return html `<p>Loading patient…</p>`;
        return html `
      <pas-banner .patient=${this.patient}></pas-banner>
      <div class="body">
        <chart-navigator .documents=${this.patient.documents ?? []}
                         .selectedId=${this.focusedDoc?.id ?? this.patient.documents?.[0]?.id ?? null}
                         @doc-focus=${this.onFocus}></chart-navigator>
        <chart-viewer .document=${this.focusedDoc ?? this.patient.documents?.[0]}></chart-viewer>
      </div>
    `;
    }
};
__decorate([
    property({ type: String })
], PasPatientView.prototype, "patientId", void 0);
__decorate([
    property({ attribute: false })
], PasPatientView.prototype, "patient", void 0);
__decorate([
    state()
], PasPatientView.prototype, "focusedDoc", void 0);
PasPatientView = __decorate([
    customElement("pas-patient-view")
], PasPatientView);
export { PasPatientView };
